export default "__VITE_ASSET__99c56674__"